@if(inputHasData)
{
  <div class="btn btn-primary" (click)="onCreate.emit()">
    <i class="pi pi-plus"></i>
    {{'@@CUSTOMER.ACTION.CONTACT_CREATE' | translate }}
  </div>

  <!-- <div (click)="onImport.emit()" class="btn btn-plane ml32">
    <i class="pi pi-upload"></i>
    {{ '@@CUSTOMER.ACTION.IMPORT' | translate}}
  </div> -->

  <!-- Project Table -->
  <div class="mt32">
    <cc-table
      [inputTableMapping]   = "$$ui.contactMapping"
      [inputDataSource]     = "inputDataSource"
      [inputHasPaging]      = "true"

      (onEdit)              = "onEdit.emit($event)"
      (onDelete)            = "onDelete.emit($event)"
      (onNavigate)          = "onNavigate.emit($event)"

      (onNext)              = "onPageChange.emit($event)"
      (onPrev)              = "onPageChange.emit($event)"

      (onSearch)            = "onSearch.emit($event)">
    </cc-table>
  </div>
}

@if(!inputHasData)
{
  <div class="no-data-found">

    <i class="pi pi-address-book fs46"></i>
    <div class="fsb32 mt8">{{ '@@CUSTOMER.NO_DATA_FOUND.CONTACT_TITLE'    | translate }} </div>
    <div class="fs16 mt16">{{ '@@CUSTOMER.NO_DATA_FOUND.CONTACT_SUBTITLE' | translate }}</div>

    <div class="mt32">
        <div (click)="onCreate.emit()" class="btn btn-primary">
          <i class="pi pi-plus"></i>
          {{'@@CUSTOMER.ACTION.CONTACT_CREATE' | translate }}
        </div>

        <!-- <div (click)="onImport.emit()" class="btn btn-plane ml32">
          <i class="pi pi-upload"></i>
          {{'@@CUSTOMER.ACTION.CONTACT_IMPORT' | translate }}
        </div> -->
    </div>
  </div>
}
